import { render, staticRenderFns } from "./PhpView.vue?vue&type=template&id=666e2b5e&scoped=true&"
import script from "./PhpView.vue?vue&type=script&lang=js&"
export * from "./PhpView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666e2b5e",
  null
  
)

export default component.exports